export default __webpack_public_path__ + "static/media/error.0dc15a84.jpg";